import './styles/datasystem-item.scss'

import React       from 'react'
import PropTypes   from 'prop-types'

export default class DataSystemItem extends React.Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
  }
  
  render() {
    const { item } = this.props

    return (
      <div className="datasystem-item">        
        { item.name }        
      </div>      
    )
  }
}